module.exports = __webpack_public_path__ + "img/1574522208.70cd31fd.jpg";